import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loadSettings: -1,
    createAdvice: -1,
    updateAdvice: -1,
    deleteAdvice: -1,
    updateFee: -1,
  },
  data: {
    adviceTemplates: [],
    opinionFee: 0,
  },
  error: null,
  templateId: null,
};

export default function reducer(state = initialState, action) {
  const {
    type, payload, extras, error,
  } = action;

  switch (type) {
    case ACTION_TYPES.LAB_SETTINGS_RETRIEVE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadSettings: 0,
        },
      };
    case ACTION_TYPES.LAB_SETTINGS_RETRIEVE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loadSettings: 1,
        },
        data: {
          ...payload,
          adviceTemplates: payload.adviceTemplates.reverse(),
        },
      };
    case ACTION_TYPES.LAB_SETTINGS_RETRIEVE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadSettings: 2,
        },
        error,
      };
    case ACTION_TYPES.LAB_SETTINGS_ADVICE_CREATE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          createAdvice: 0,
        },
      };
    case ACTION_TYPES.LAB_SETTINGS_ADVICE_CREATE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          createAdvice: 1,
        },
        data: {
          ...payload,
          adviceTemplates: payload.adviceTemplates.reverse(),
        },
      };
    case ACTION_TYPES.LAB_SETTINGS_ADVICE_CREATE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          createAdvice: 2,
        },
        error,
      };
    case ACTION_TYPES.LAB_SETTINGS_ADVICE_UPDATE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          updateAdvice: 0,
        },
      };
    case ACTION_TYPES.LAB_SETTINGS_ADVICE_UPDATE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          updateAdvice: 1,
        },
        data: {
          ...payload,
          adviceTemplates: payload.adviceTemplates.reverse(),
        },
      };
    case ACTION_TYPES.LAB_SETTINGS_ADVICE_UPDATE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          updateAdvice: 2,
        },
        error,
      };
    case ACTION_TYPES.LAB_SETTINGS_ADVICE_DELETE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          deleteAdvice: 0,
        },
      };
    case ACTION_TYPES.LAB_SETTINGS_ADVICE_DELETE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          deleteAdvice: 1,
        },
        data: {
          ...state.data,
          adviceTemplates: state.data.adviceTemplates.filter(item => item.id !== extras.adviceId),
        },
      };
    case ACTION_TYPES.LAB_SETTINGS_ADVICE_DELETE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          deleteAdvice: 2,
        },
        error,
      };
    case ACTION_TYPES.LAB_SETTINGS_FEE_UPDATE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          updateFee: 0,
        },
      };
    case ACTION_TYPES.LAB_SETTINGS_FEE_UPDATE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          updateFee: 1,
        },
        data: {
          ...payload,
          adviceTemplates: payload.adviceTemplates.reverse(),
        },
      };
    case ACTION_TYPES.LAB_SETTINGS_FEE_UPDATE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          updateFee: 2,
        },
        error,
      };
    default:
      return state;
  }
}
